module.exports = __webpack_public_path__ + "files/fd9103fcb16c3e9031449a42e62b0d06.png";